export { MaterialsDocsPage } from './MaterialsDocsPage/MaterialsDocsPage';
export { MaterialsEventsPage } from './MaterialsEventsPage/MaterialsEventsPage';
export { MaterialsFeedbackPage } from './MaterialsFeedbackPage/MaterialsFeedbackPage';
export { MaterialsResearchPage } from './MaterialsResearchPage/MaterialsResearchPage';
